<template>
    <div id="ComingSoon">
        <div class="coming-soon-image">
            <ComingSoonDataIcon style="width: 400px; height: 250px" />
        </div>
        <div class="coming-soon-text">
            <h3>{{ noDataText || "No content added" }}</h3>
            <p>Scrap or add content, which AI Assist can use to respond to your customers' queries</p>
        </div>
        <div class="comming-soon-btn-container">
            <SupsisButton ghost :disabled="disabled">
                <span>How it works</span>
            </SupsisButton>
            <SupsisButton primary @click="() => addContent()" :disabled="disabled">
                <i class="material-icons">add</i>
                <span>{{ actionText || "Add content" }}</span>
            </SupsisButton>
        </div>
    </div>
</template>
<script>
import ComingSoonDataIcon from "../pages/integrations/svg/ComingSoonDataIcon.vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";

export default {
    name: "ComingSoonData",
    components: {
        ComingSoonDataIcon,
        SupsisButton,
    },
    props: {
        addContent: {
            type: Function,
            default: () => {},
        },
        actionText: {
            type: String,
        },
        noDataText: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
<style scoped lang="scss">
#ComingSoon {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .coming-soon-image {
        width: 400px;
        height: 250px;
    }

    .coming-soon-text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        h3 {
            font-size: 24px;
            font-weight: 700;
            color: var(--color-text-strong-default);
            line-height: 32px;
        }

        p {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-default);
            line-height: 24px;
        }
    }

    .comming-soon-btn-container {
        display: flex;
        gap: 20px;
        justify-content: center;
        align-items: center;
    }
}
</style>
